import request from '@/utils/request'

let Coach_coachApi = {
    getJzList(data){
        return request._post('/shop/plus.coach_coach.Index/getdatemenu', data);
    },

  /*兼职教练列表*/
  list(data) {
    return request._post('/shop/plus.coach_coach.Index/index', data);
},
/*添加兼职教练*/
add(data) {
    return request._post('/shop/plus.coach_coach.Index/add', data);
},
/*修改兼职教练*/
edit(data) {
    return request._post('/shop/plus.coach_coach.Index/edit', data);
},
/*删除兼职教练*/
del(data) {
    return request._post('/shop/plus.coach_coach.Index/del', data);
},
/*兼职教练详情*/
detail(data) {
  return request._post('/shop/plus.coach_coach.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.coach_coach.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.coach_coach.Setting/getSetting', data, errorback);
    },
}
export default Coach_coachApi;



// WEBPACK FOOTER //
// ./src/api/coach_coach.js